import { RosterState, RosterAction, RosterActionType } from './types'

export const initialRosterState: RosterState = {
  loading: true,
  loadingRosters: true,
  error: null,
  rosters: [],
  selectedRosterId: '',
  roster: {},
  players: [],
  affiliates: [],
  teamOfficials: [],
  permissions: {},
  lockRosterDate: null,
  canAddPlayersFromRoster: false,
  isRegistrationOn: false,
  requireEmail: false,
  shouldShowWaiver: false,
}

export const rosterReducer = (
  state: RosterState,
  action: RosterAction
): RosterState => {
  switch (action.type) {
    case RosterActionType.SET_LOADING:
      return { ...state, loading: action.payload }

    case RosterActionType.SET_LOADING_ROSTERS:
      return { ...state, loadingRosters: action.payload }

    case RosterActionType.SET_ROSTER_DATA:
      return {
        ...state,
        loading: false,
        roster: action.payload.roster,
        players: action.payload.players,
        affiliates: action.payload.affiliates,
        teamOfficials: action.payload.teamOfficials,
        permissions: action.payload.permissions,
        lockRosterDate: action.payload.lockRosterDate,
        canAddPlayersFromRoster: action.payload.canAddPlayersFromRoster,
        isRegistrationOn: action.payload.isRegistrationOn,
        requireEmail: action.payload.requireEmail,
        shouldShowWaiver: action.payload.shouldShowWaiver,
      }

    case RosterActionType.SET_ERROR:
      return { ...state, error: action.payload, loading: false }

    case RosterActionType.SET_SELECTED_ROSTER:
      return { ...state, selectedRosterId: action.payload }

    case RosterActionType.SET_ROSTERS:
      return { ...state, rosters: action.payload, loadingRosters: false }

    default:
      return state
  }
}
